import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../react-core/Flux/Dispatcher";
import { BusinessManagementPropositionStatic } from "./BusinessManagementPropositionStatic";
import { BusinessManagementStatic } from "./BusinessManagementStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const BusinessManagementDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const BusinessManagementStore: BusinessManagementStatic = new BusinessManagementStatic();

export const BusinessManagementPropositionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const BusinessManagementPropositionStore: BusinessManagementPropositionStatic = new BusinessManagementPropositionStatic();
